import script from "./productStock.vue?vue&type=script&lang=ts&setup=true"
export * from "./productStock.vue?vue&type=script&lang=ts&setup=true"

import "./productStock.vue?vue&type=style&index=0&id=73964996&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73964996"]])

export default __exports__